import { LayoutGrid, Star, Palette } from 'lucide-react'
import { Becy } from '@/components/ui/icon'
import type { CasinoTypeId } from '@/types/casino'

export const CASINO_TYPE_LOBBY: CasinoTypeId = 'lobby'
export const CASINO_TYPE_POPULAR: CasinoTypeId = 'popular'
export const CASINO_TYPE_ORIGINALS: CasinoTypeId = 'originals'
export const CASINO_TYPE_PROVIDERS: CasinoTypeId = 'providers'

export const CASINO_GAMES_PER_CAROUSEL = 9
export const CASINO_GAMES_LOAD_MORE_CAROUSEL = 4
export const CASINO_GAMES_PER_PAGE = 36
export const CASINO_GAMES_LOAD_MORE = 18
export const CASINO_PROVIDERS_PER_CAROUSEL = 6
export const CASINO_PROVIDERS_PER_PAGE = 18
export const CASINO_HOME_GAMES_COUNT = 9
export const CASINO_SKELETON_CARD_COUNT = 9
export const CASINO_PLAY_GAMES_PER_CAROUSEL = 7

export const DEFAULT_CASINO_TYPES = [
	{ id: CASINO_TYPE_LOBBY, label: 'Lobby', icon: LayoutGrid },
	{ id: CASINO_TYPE_POPULAR, label: 'Popular', icon: Star },
	{ id: CASINO_TYPE_ORIGINALS, label: 'Originals', icon: Becy },
] as const

export const CASINO_PROVIDERS_NAV_TYPE = {
	id: CASINO_TYPE_PROVIDERS,
	label: 'Providers',
	icon: Palette,
} as const

export const CASINO_VOLATILITY_LABELS: Record<number, string> = {
	1: 'Low',
	2: 'Low-Medium',
	3: 'Medium',
	4: 'High',
	5: 'Very High',
}

export const CASINO_BANNER_ASSETS = {
	depositBonus: '/images/casino/becy-model.png',
	loyaltyBoost: '/images/casino/becy-tier.png',
} as const

export const CASINO_GAME_PLACEHOLDER_IMAGE = '/images/casino/game-placeholder.png'
